/*
This page will not be served to end users.
40x error pages are rendered in utils/page.js as normal pages
50x in Proxy gateway
*/
const NextErrorPage = () => null

export default NextErrorPage
